import { motion, useInView } from "framer-motion"
import { graphql, Link } from "gatsby"
import parse from "html-react-parser"
import React, { useEffect, useRef, useState } from "react"
import ImageOpt from "./ImageOpt"

const FullImageWithMap = ({ module }) => {
  const ref = useRef(null)
  const [hasPlayed, setHasPlayed] = useState(false)
  const isInView = useInView(ref)

  const sectionShow = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const animFade = {
    hidden: { opacity: 0, y: 20 },
    show: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: "easeInOut",
        delayChildren: 0.5,
        staggerChildren: 0.2,
      },
    },
  }
  const [tab, setTab] = useState("tab-1")

  useEffect(() => {
    if (isInView && !hasPlayed) {
      setHasPlayed(true)
    }
  }, [isInView, hasPlayed, setHasPlayed])

  if (module.hideSection === "no") {
    return (
      <React.Fragment>
        <motion.section
          initial="hidden"
          animate={isInView || hasPlayed ? "show" : "hidden"}
          variants={sectionShow}
          className={`genral-tab-content py-110 xlscreen:py-80 mdscreen:py-45 ${
            module.extraClass ? ` ${module.extraClass}` : ""
          }`}
          id={module.extraId}
        >
          <motion.div
            ref={ref}
            initial="hidden"
            animate={isInView || hasPlayed ? "show" : "hidden"}
            variants={sectionShow}
            className="container-fluid-md"
          >
            <div className="max-w-[573px] mx-auto text-center">
              {module?.heading && (
                <motion.div
                  variants={animFade}
                  className="title title-grey grey-separator-both uppercase"
                >
                  <h2>{module.heading}</h2>
                </motion.div>
              )}
              {module?.description && (
                <motion.div variants={animFade} className="content pt-15">
                  <p>{parse(module.description)}</p>
                </motion.div>
              )}
              {module?.button && (
                <motion.div variants={animFade} className="pt-25">
                  <Link
                    to={module.button.url}
                    className="btn btn-grey"
                    target={module?.button.target}
                  >
                    {module?.button.title}
                  </Link>
                </motion.div>
              )}
            </div>

            <motion.div variants={animFade} className="tabs-main">
              <ul className="flex justify-end items-center gap-x-25 tabs mdscreen:pt-15">
                <li
                  onClick={() => setTab("tab-1")}
                  className={`cursor-pointer text-black-100 border ${
                    tab === "tab-1" ? "current-tab" : ""
                  }`}
                  onKeyDown={() => setTab("tab-1")}
                  aria-hidden="true"
                >
                  <img
                    src="../../images/img-icon.svg"
                    alt="img-icon"
                    height={26}
                    width={26}
                    loading="lazy"
                  />
                </li>
                <li
                  onClick={() => setTab("tab-2")}
                  className={`cursor-pointer text-black-100 border ${
                    tab === "tab-2" ? "current-tab" : ""
                  }`}
                  onKeyDown={() => setTab("tab-2")}
                  aria-hidden="true"
                >
                  <img
                    src="../../images/map-icon.svg"
                    alt="map-icon"
                    height={24}
                    width={24}
                    loading="lazy"
                  />
                </li>
              </ul>
              <div className="tab-container pt-45 mdscreen:pt-30">
                {tab === "tab-1" && (
                  <div className="border-bg-offwhite">
                    <div className="img">
                      <ImageOpt
                        imgData={module.image.mediaItemUrl}
                        imgAlt={module.image.title}
                        imgClass=""
                        width={2000}
                        height={1337}
                        imgLoad="lazy"
                      />
                    </div>
                  </div>
                )}
                {tab === "tab-2" && (
                  <div className="border-bg-offwhite">
                    <div className="img map">
                      <ImageOpt
                        imgData={module.mapImage.mediaItemUrl}
                        imgAlt={module.mapImage.title}
                        imgClass=""
                        width={677}
                        height={1337}
                        imgLoad="lazy"
                      />
                    </div>
                  </div>
                )}
              </div>
            </motion.div>
          </motion.div>
        </motion.section>
      </React.Fragment>
    )
  }
}

export default FullImageWithMap
export const PageFullImageWithMapFragment = graphql`
  fragment PageFullImageWithMapFragment on WpPage_Pagecontent_PageContent_FullImageWithMap {
    extraClass
    extraId
    hideSection
    description
    heading
    image {
      altText
      mediaItemUrl
      title
    }
    mapIframe
    mapImage {
      altText
      mediaItemUrl
      title
    }
    button {
      target
      title
      url
    }
  }
`
